<template>
  <div class="video-container" :class="[currentClass, {'video-container_edge': isEdge}]">
    <template v-if="!mobile">
      <video ref="video_home" muted :class="{'active': isActive('home')}" :autoplay="isActive('home')" data-object-fit="cover">
        <source src="/f/dist/static/video/home.mp4" type="video/mp4">
        <source src="/f/dist/static/video/home.webm" type="video/webm">
        <source src="/f/dist/static/video/home.ogv" type="video/ogg">
      </video>
      <video ref="video_team" muted :class="{'active': isActive('team')}" :autoplay=" currentPage === 'team'" data-object-fit="cover">
        <source src="/f/dist/static/video/team.mp4" type="video/mp4">
        <source src="/f/dist/static/video/team.webm" type="video/webm">
        <source src="/f/dist/static/video/team.ogv" type="video/ogg">
      </video>
      <video ref="video_portfolio" muted :class="{'active': isActive('portfolio')}" :autoplay="currentPage === 'portfolio'" data-object-fit="cover">
        <source src="/f/dist/static/video/portfolio.mp4" type="video/mp4">
        <source src="/f/dist/static/video/portfolio.webm" type="video/webm">
        <source src="/f/dist/static/video/portfolio.ogv" type="video/ogg">
      </video>
      <video ref="video_privateequity" muted :class="{'active': isActive('privateequity')}" :autoplay="currentPage === 'privateequity'" data-object-fit="cover">
        <source src="/f/dist/static/video/privateequity.mp4" type="video/mp4">
        <source src="/f/dist/static/video/privateequity.webm" type="video/webm">
        <source src="/f/dist/static/video/privateequity.ogv" type="video/ogg">
      </video>
      <video ref="video_founders" muted :class="{'active': isActive('founders')}" :autoplay=" currentPage === 'founders'" data-object-fit="cover">
        <source src="/f/dist/static/video/founders.mp4" type="video/mp4">
        <source src="/f/dist/static/video/founders.webm" type="video/webm">
        <source src="/f/dist/static/video/founders.ogv" type="video/ogg">
      </video>
    </template>
    <template v-else>
      <img ref="video_home" src="/f/dist/static/img/home.jpg" :class="{'active': isActive('home')}" data-object-fit="cover"/>
      <img ref="video_team" src="/f/dist/static/img/team.jpg" :class="{'active': isActive('team')}" data-object-fit="cover"/>
      <img ref="video_portfolio" src="/f/dist/static/img/portfolio.jpg" :class="{'active': isActive('portfolio')}" data-object-fit="cover"/>
      <img ref="video_privateequity" src="/f/dist/static/img/privateequity.jpg" :class="{'active': isActive('privateequity')}" data-object-fit="cover"/>
      <img ref="video_founders" src="/f/dist/static/img/founders.jpg" :class="{'active': isActive('founders')}" data-object-fit="cover"/>
    </template>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import browserDetect from '@/helpers/browserDetect';

  export default {
    name: 'videoContainer',
    props: ['currentPage'],
    computed: {
      ...mapGetters({
        mobile: 'mobile',
      }),
      currentClass() {
        return 'video-container_'.concat(this.currentPage);
      },
    },
    data() {
      return {
        isEdge: false,
      };
    },
    methods: {
      isActive(item) {
        const checkVideo = this.$refs[`video_${item}`];
        const videoIsShown = this.currentPage === item;

        if (videoIsShown && checkVideo && checkVideo.playing) return videoIsShown;

        if (videoIsShown && checkVideo && !this.mobile) {
          checkVideo.style.display = 'block';
          checkVideo.play();
        }

        if (!videoIsShown && checkVideo && checkVideo.playing) {
          setTimeout(() => {
            checkVideo.pause();
            checkVideo.style.display = 'none';
          }, 1000);
        }

        return videoIsShown;
      },
      setPageLoadedAndReady() {
        this.$store.commit('LOADED_PAGE', true);

        setTimeout(() => {
          this.$store.commit('READY_PAGE', true);
        }, 1200);
      },
      edgeDetector() {
        const edgeCheck = (browserDetect() === 'edge');
        return edgeCheck;
      },
    },
    mounted() {
      this.isEdge = this.edgeDetector();
      if (!this.mobile) {
        this.$refs.video_home.addEventListener('loadeddata', () => {
          this.setPageLoadedAndReady();
        }, false);
      } else if (this.$refs.video_home) {
        this.setPageLoadedAndReady();
      }
    },
  };
</script>

<style scoped>
  .video-container {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 0;

    video,
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      object-fit: cover;
      object-position: top left;
      transform: scale(1.1);
      transition: opacity 1s ease, transform 1s ease;

      &.active {
        opacity: 1;
        transform: scale(1);
      }
    }

    &.video-container_edge {
      video {
        width: auto;
        height: auto;
        min-width: 100%;
        min-height: 100%;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/VideoContainer.vue?2f71653f